export function validateZipCode(zipCode) {
    const zipRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
    return zipRegex.test(zipCode);
}
